import { CustomerType, ICustomer } from 'admiral-core';

/** Formatierter Anzeigename eines CRM-Kunden. */
export function formatCustomerDisplayName(customer: {
  type?: CustomerType;
  name?: string;
  firstname?: string;
  lastname?: string;
}): string {
  if (customer.type === CustomerType.LEGAL) {
    return (customer.name || '').trim();
  }
  return [customer.firstname, customer.lastname].filter(Boolean).join(' ').trim();
}

/** Baut eine mehrzeilige Adresszeile aus Straße, PLZ, Ort und Zusatz. */
export function formatCustomerAddress(customer: {
  street?: string;
  zip?: string;
  city?: string;
  addressSupplement?: string;
}): string {
  const lines: string[] = [];
  if (customer.street?.trim()) {
    lines.push(customer.street.trim());
  }
  const zipCity = [customer.zip?.trim(), customer.city?.trim()].filter(Boolean).join(' ');
  if (zipCity) {
    lines.push(zipCity);
  }
  if (customer.addressSupplement?.trim()) {
    lines.push(customer.addressSupplement.trim());
  }
  return lines.join('\n');
}

/** Prüft, ob mindestens ein Adressfeld gesetzt ist. */
export function hasCustomerAddress(customer: Pick<
  ICustomer,
  'street' | 'zip' | 'city' | 'addressSupplement'
>): boolean {
  return !!(
    customer.street?.trim() ||
    customer.zip?.trim() ||
    customer.city?.trim() ||
    customer.addressSupplement?.trim()
  );
}

/** Formatiert Festnetz und Mobil für die Anzeige. */
export function formatCustomerPhones(customer: {
  phoneLandline?: string;
  phoneMobile?: string;
}): string {
  const parts = [customer.phoneLandline, customer.phoneMobile].filter((p) => p?.trim());
  return parts.length ? parts.join(' · ') : '–';
}
